<template>
    <Page :header="header[lang].title">
        <template v-slot:body>
            <div class="w-full flex flex-column gap-2">
                <Tabs v-model:value="active" class="w-full" :scrollable="true">
                    <TabList>
                        <Tab :value="0">{{ tabs[0].title }}</Tab>
                        <Tab :value="1">{{ tabs[1].title }}</Tab>
                        <Tab :value="2">{{ tabs[2].title }}</Tab>
                        <Tab :value="3">{{ tabs[3].title }}</Tab>
                        <Tab :value="4">{{ tabs[4].title }}</Tab>
                    </TabList>
                    <!-- WALLETS -->
                    <TabPanel :value="0" class="py-3" :scrollable="true">
                        <div v-if="wallet" class="flex flex-column">
                            <MobMenu :items="[]" colorType="gray">
                                <template v-slot:body>
                                    <div class="w-full flex flex-row px-3 py-2 border-200 border-bottom-1" style="min-height:50px" @click="toWallet('freeze')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Заморозка</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.freeze, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-row px-3 py-2 border-200 border-bottom-1" style="min-height:50px" @click="toWallet('comission')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Комиссии</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.comission, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-row px-3 py-2 border-200 border-bottom-1" style="min-height:50px" @click="toWallet('vendor')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Вендор</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.vendor, 'usdt', 2) }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-row px-3 py-2 border-200 border-bottom-1" style="min-height:50px" @click="toWallet('fund')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Фонды</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.fund, 'usdt', 2) }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-row px-3 py-2 border-200 border-bottom-1" style="min-height:50px" @click="toWallet('liquidity')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Ликвидность</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.liquidity, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-row px-3 py-2 border-200 border-bottom-1" style="min-height:50px" @click="toWallet('withdraw')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Вывод</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.withdraw, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-row px-3 py-2 border-bottom-0" style="min-height:50px" @click="toWallet('service')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Сервис</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(wallet.service, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                </template>
                            </MobMenu>
                        </div>
                        <Skeleton v-if="loading" height="2rem" />
                    </TabPanel>

                    <!-- MERCHANTs -->
                    <TabPanel :value="1" class="py-3">
                        <div v-if="merchant">
                            <MobMenu :items="[]" colorType="gray">
                                <template v-slot:body>
                                    <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1" style="min-height:50px" @click="toWallet('merchant')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Мерчанты</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(merchant.total_balance, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                </template>
                            </MobMenu>
                        </div>
                        <Skeleton v-if="loading" height="2rem" />
                    </TabPanel>

                    <!-- DEPOSITS -->
                    <TabPanel :value="2" class="py-3">
                        <div v-if="deposit">
                            <MobMenu :items="[]" colorType="gray">
                                <template v-slot:body>
                                    <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1" style="min-height:50px" @click="toWallet('deposit')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Депозиты</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(deposit.total_balance, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                </template>
                            </MobMenu>
                        </div>
                        <Skeleton v-if="loading" height="2rem" />
                    </TabPanel>

                    <!-- VCARDs -->
                    <TabPanel :value="3" class="py-3">
                        <div v-if="vcard">
                            <MobMenu :items="[]" colorType="gray">
                                <template v-slot:body>
                                    <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1" style="min-height:50px" @click="toWallet('vcard')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Карты</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(vcard.total_balance, 'usdt', 2) }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                </template>
                            </MobMenu>
                        </div>
                        <Skeleton v-if="loading" height="2rem" />
                    </TabPanel>

                    <!-- PARTNERS -->
                    <TabPanel :value="4" class="py-3">
                        <div v-if="partner">
                            <MobMenu :items="[]" colorType="gray">
                                <template v-slot:body>
                                    <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1" style="min-height:50px" @click="toWallet('partner')" :class="(isUserInGroup('admin') ? 'cursor-pointer' : '')">
                                        <div class="flex flex-1 justify-content-left align-items-center">
                                            <span class="text-600">Партнеры</span>
                                        </div>
                                        <div class="flex justify-content-right align-items-center">
                                            <span class="text-sm uppercase font-medium">{{ get_format_amount(partner.total_balance, 'usdt') }}</span>
                                            <i class="text-blue-500 ml-2 pi pi-angle-right" v-if="isUserInGroup('admin')"/>
                                        </div>
                                    </div>
                                </template>
                            </MobMenu>
                        </div>
                        <Skeleton v-if="loading" height="2rem" />
                    </TabPanel>
                </Tabs>
            </div>
        </template> 
    </Page>
</template>

<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import { mapActions }   from 'vuex'
import MobMenu          from '@/components/sides/menu/MobMenu.vue'
import Page             from '@/components/sides/Page.vue' 

export default {
    data() {
        return {
            header: {
                en: {title: "Stat"} ,
                ru: {title: "Статистика"} ,
            },
            admin_data: null,
            active: 0,
            tabs: [
                { title: 'Кошельки', content: 'wallet' },
                { title: 'Торговые', content: 'merchant' },
                { title: 'Депозиты', content: 'deposit' },
                { title: 'Карты', content: 'vcard' },
                { title: 'Партнеры', content: 'partner' },
            ],
            loading: false,
            wallet: null,
            merchant: null,
            deposit: null,
            partner: null,
            vcard: null,
        }
    },
    components: {
        MobMenu,
        Page
    },  
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        getStatusLabel (status) {
            return this.helper.get_severity_status(status, 'RU')
        },
        get_format_amount(value, currency, digits = 0) {
            return this.helper.format_amount(value, currency, digits)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        toWallet(type){
            if(!this.isUserInGroup('admin')) return
            this.$router.push({path: '/admin/wallets/', query: {type: type}})
        },
        ...mapActions(['UpdateHeader']),
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang].title,
                backButton: true,
                backButtonUrl: '/admin/',
                profileButton: false
            });
        },
        async get_admin_data(code){
            if(!code) return
            this.loading = true
            const data = await this.connect.get_admin_data(code).then(res=>res)
            if(!data.result || !data.data) {
                if(data.errors) this.showMess('error', 'Ошибка', data.errors[0])
                else this.showMess('error', 'Ошибка', 'Ошибка сервера')
                this.loading = false
                return
            }
            if(code == 'merchant') this.merchant = data.data
            if(code == 'deposit') this.deposit = data.data
            if(code == 'partner') this.partner = data.data
            if(code == 'wallet') this.wallet = data.data
            if(code == 'vcard') this.vcard = data.data
            this.loading = false
        }
    },
    watch : {
        active: function (val) {
            this.get_admin_data(this.tabs[val].content)
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.get_admin_data('wallet')
        this.helper.SetTgAppBackButton(false)
        this.updateHeader()
    }
}
</script>